import { render, staticRenderFns } from "./DeploymentRequirements.vue?vue&type=template&id=14599418&"
import script from "./DeploymentRequirements.vue?vue&type=script&lang=ts&"
export * from "./DeploymentRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports